<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container">
        <router-link class="navbar-brand" :to="{name: 'Home'}"><img src="@/assets/images/jadwellha.svg" alt="" /></router-link>
        <button class="navbar-toggler d-lg-none d-flex flex-column gap-1 border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <img src="@/assets/images/burger.svg" alt="">
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item ms-3">
              <router-link class="nav-link fw-bold fs-14px" aria-current="page" :to="{name: 'Home'}">الرئيسية</router-link>
            </li>
            <li class="nav-item ms-3 fw-bold">
              <router-link class="nav-link fs-14px" :to="{name: 'Schedules'}">مواعيدي</router-link>
            </li>
            <li class="nav-item ms-3">
              <router-link :to="{name: 'Platforms'}" class="nav-link fs-14px fw-bold" href="#">ربط الخدمات</router-link>
            </li>
            <li class="nav-item ms-3">
              <a class="nav-link fs-14px fw-bold" href="#">مركز المساعدة</a>
            </li>
          </ul>
          <div class="d-lg-flex d-none gap-1 align-items-center">
            <div class="dropdown notfy-dropdown position-relative">
              <a class="btn p-0 dropdown-toggle d-flex align-items-center text-start" href="#" role="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false">
                <div class="bell border-2">
                  <div class="notfy bg-success"></div>
                  <img src="@/assets/images/icons-Bell-Line.png" alt="" />
                </div>
              </a>

              <div class="dropdown-menu border-0 bg-light p-3" aria-labelledby="dropdownMenuLink">
                <h5 class="fs-4 fw-bold">الإشعارات</h5>
                <div class="d-flex flex-column">
                  <!-- Notifiaction Item -->
                  <a href="#" class="text-decoration-none border-bottom py-1">
                    <div class="d-flex align-items-center">
                      <span class="fw-14px fw-bold">أهلا بكم في جدولها</span>
                      <div class="notfy bg-success ms-auto"></div>
                    </div>
                    <span class="fs-10px text-secondary">2021-03-10 20:19:15</span>
                  </a>
                  <!-- Notifiaction Item -->
                  <a href="#" class="text-decoration-none border-bottom py-1">
                    <div class="d-flex align-items-center">
                      <span class="fw-14px text-black fw-bold">أهلا بكم في جدولها</span>
                      <div class="notfy bg-success ms-auto"></div>
                    </div>
                    <span class="fs-10px text-secondary">2021-03-10 20:19:15</span>
                  </a>
                  <!-- Notifiaction Item -->
                  <a href="#" class="text-decoration-none border-bottom py-1">
                    <div class="d-flex align-items-center">
                      <span class="fw-14px fw-bold">أهلا بكم في جدولها</span>
                      <div class="notfy bg-success ms-auto"></div>
                    </div>
                    <span class="fs-10px text-secondary">2021-03-10 20:19:15</span>
                  </a>
                  <!-- Notifiaction Item -->
                  <a href="#" class="text-decoration-none border-bottom py-1">
                    <div class="d-flex align-items-center">
                      <span class="fw-14px fw-bold">أهلا بكم في جدولها</span>
                      <div class="notfy bg-success ms-auto"></div>
                    </div>
                    <span class="fs-10px text-secondary">2021-03-10 20:19:15</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="vertical-seperator d-lg-block d-none"></div>
            <div class="dropdown account-dropdown">
              <a class="btn p-0 dropdown-toggle d-flex align-items-center text-start" href="#" role="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false">
                <img src="@/assets/images/user.png" width="40" alt="" />
                <div class="d-flex flex-column mx-3">
                  <span class="text-secondary text-secondary fs-6 fw-bold">مدحت عودة</span>
                  <span class="fw-bold fs-6 fw-bold">فريق مساق</span>
                </div>
                <img src="@/assets/images/chevron-down.svg" alt="" />
              </a>

              <div class="dropdown-menu border-0 bg-light p-3" aria-labelledby="dropdownMenuLink">
                <h5 class="fs-6 fw-bold">الفريق</h5>
                <div class="d-flex flex-column shadow-sm team-list">
                  <a href="#" class="account-item d-flex align-items-center w-100 p-3">
                    <img class="account-img" src="@/assets/images/msaaq.svg" alt="" />
                    <div class="d-flex flex-column ms-2">
                      <span class="fs-14px text-black fw-bold">مساق</span>
                      <div class="text-success fs-10px">
                        <img src="@/assets/images/newnotfy.svg" width="6" height="6" alt="" />
                        24 موعد جديد
                      </div>
                    </div>
                    <router-link :to="{name:'Team'}" class="ms-auto">
                      <img src="@/assets/images/settings.svg" class="opacity-75" width="18" alt="" />
                    </router-link>
                  </a>
                  <a href="#" class="account-item d-flex align-items-center w-100 p-3">
                    <img class="account-img" src="@/assets/images/blora.jpg" alt="" />
                    <div class="d-flex flex-column ms-2">
                      <span class="fs-14px text-black fw-bold">بلورة</span>
                      <div class="text-success fs-10px">
                        <img src="@/assets/images/newnotfy.svg" width="6" height="6" alt="" />
                        24 موعد جديد
                      </div>
                    </div>
                    <router-link :to="{name:'Team'}" class="ms-auto">
                      <img src="@/assets/images/settings.svg" class="opacity-75" width="18" alt="" />
                    </router-link>
                  </a>
                </div>
                <!-- Create Team button -->
                <div class="bg-success create-team mx-auto">
                  <button class="mx-auto btn d-flex gap-2 fw-14px text-white fw-bold">
                    <div class="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <g id="plus" transform="translate(-4 -4)">
                          <path id="Line_1" data-name="Line 1" d="M-.086,13A.9.9,0,0,1-1,12.125V-.125A.9.9,0,0,1-.086-1a.9.9,0,0,1,.914.875v12.25A.9.9,0,0,1-.086,13Z" transform="translate(11.086 5)" fill="currentColor" />
                          <path id="Line_2" data-name="Line 2" d="M12.125.828H-.125A.9.9,0,0,1-1-.086.9.9,0,0,1-.125-1h12.25A.9.9,0,0,1,13-.086.9.9,0,0,1,12.125.828Z" transform="translate(5 11.086)" fill="currentColor" />
                        </g>
                      </svg>
                    </div>
                    إنشاء فريق جديد
                  </button>
                </div>
                <!-- Settings -->
                <div class="d-flex flex-column mt-3">
                  <a href="#" class="settings-item border-bottom d-flex flex-column align-items-start w-100 p-2">
                    <div class="d-flex align-items-center">
                      <img src="@/assets/images/invoice-gray.svg" class="me-2" alt="" />
                      <span class="fs-14px text-black">الإشتراك والفواتير</span>
                    </div>
                    <div class="fs-10px mx-4 text-secondary">لترقية الحساب وعرض الفواتير وطرق الدفع</div>
                  </a>
                  <a href="#" class="settings-item border-bottom d-flex flex-column align-items-start w-100 p-2">
                    <div class="d-flex align-items-center">
                      <img src="@/assets/images/cog.svg" class="me-2" alt="" />
                      <span class="fs-14px text-black">الإعدادات</span>
                    </div>
                    <div class="fs-10px mx-4 text-secondary">لعرض والتعديل على البيانات</div>
                  </a>
                  <a href="#" class="settings-item border-bottom d-flex flex-column align-items-start w-100 p-2">
                    <div class="d-flex align-items-center w-100">
                      <img src="@/assets/images/light-mode.svg" class="me-2" alt="" />
                      <span class="fs-14px text-black">النمط الداكن</span>
                      <div class="switch-box primary d-flex align-items-center ms-auto">
                        <input type="checkbox" checked id="theme-switcher" />
                        <label for="theme-switcher">Toggle</label>
                      </div>
                    </div>
                    <div class="fs-10px mx-4 text-secondary">للإنتقال بين النمط الداكن والفاتح</div>
                  </a>
                  <a href="#" class="settings-item d-flex flex-column align-items-start w-100 p-2">
                    <div class="d-flex align-items-center">
                      <img src="@/assets/images/sign-out.svg" class="me-2" alt="" />
                      <span class="fs-14px text-black">تسجيل الخروج</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<style lang="scss">
.router-link-active {
  color: #000 !important;
  font-weight: bold !important;
}
</style>
